import React from 'react';

const Heading = ({ title, subtitle, className = "" }) => {
    return (
        <div className="">
            <p className={`textblack font-medium ${className}`}>{title}</p>
            {subtitle && <h2>{subtitle}</h2>}
        </div>
    );
};

export default Heading;

